import { render, staticRenderFns } from "./ProductCourses.vue?vue&type=template&id=5763e050&scoped=true"
import script from "./ProductCourses.vue?vue&type=script&lang=js"
export * from "./ProductCourses.vue?vue&type=script&lang=js"
import style0 from "./ProductCourses.vue?vue&type=style&index=0&id=5763e050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5763e050",
  null
  
)

export default component.exports